import { useState } from 'react';

import Input from '@/shared/components/UI/Input';
import Button from '@/shared/components/UI/Button';
import TermsOfServiceModal from '@/shared/components/UI/TermsOfServiceModal';

import { useGetUserInfo } from '../hooks/useGetUserInfo';
import { useHandleSubmit } from '../hooks/useHandleSubmit';

const ContactUs = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const {
    handleSubmit,
    errors,
    contactUsForm,
    setContactUsForm,
    handleInputChange,
  } = useHandleSubmit();
  const { userInfoFetched } = useGetUserInfo(setContactUsForm);

  return (
    <section className="mx-auto mb-20 mt-10 w-full max-w-[58rem] rounded-2xl bg-white px-5 py-[60px] text-center shadow-[0_2px_12px_#adb5bd40]">
      <h3 className="mb-12 text-[2.25rem] font-extrabold leading-[44px] tracking-wider text-[#95699f]">
        CONTACT US
      </h3>
      <form className="mt-10" onSubmit={handleSubmit} noValidate>
        <div className="mx-auto my-8 max-w-[34.25rem]">
          <Input
            label="Business registration number"
            name="businessRegistrationNumber"
            value={contactUsForm.businessRegistrationNumber}
            onChange={handleInputChange}
            placeholder="Enter Business registration number"
            error={errors.businessRegistrationNumber}
            disabled={
              userInfoFetched && !!contactUsForm.businessRegistrationNumber
            }
            labelClassName="text-[16px] text-[#4a4a4a]"
            className="mt-2 text-[16px] placeholder:text-[16px]"
          />
        </div>
        <div className="mx-auto my-8 max-w-[34.25rem]">
          <Input
            label="Company Name"
            name="companyName"
            value={contactUsForm.companyName}
            onChange={handleInputChange}
            placeholder="Enter Company name"
            error={errors.companyName}
            disabled={userInfoFetched && !!contactUsForm.companyName}
            labelClassName="text-[16px] text-[#4a4a4a]"
            className="mt-2 text-[16px] placeholder:text-[16px]"
          />
        </div>
        <div className="mx-auto my-8 max-w-[34.25rem]">
          <Input
            label="Representative Name"
            name="representativeName"
            value={contactUsForm.representativeName}
            onChange={handleInputChange}
            placeholder="Enter Representative name"
            error={errors.representativeName}
            disabled={userInfoFetched && !!contactUsForm.representativeName}
            labelClassName="text-[16px] text-[#4a4a4a]"
            className="mt-2 text-[16px] placeholder:text-[16px]"
          />
        </div>
        <div className="mx-auto my-8 max-w-[34.25rem]">
          <Input
            label="Email"
            type="email"
            name="email"
            value={contactUsForm.email}
            onChange={handleInputChange}
            placeholder="Enter Email"
            error={errors.email}
            labelClassName="text-[16px] text-[#4a4a4a]"
            className="mt-2 text-[16px] placeholder:text-[16px]"
          />
        </div>
        <div className="mx-auto my-8 max-w-[34.25rem]">
          <Input
            label="Phone number"
            type="tel"
            name="phoneNumber"
            value={contactUsForm.phoneNumber}
            onChange={handleInputChange}
            placeholder="Enter Phone number"
            error={errors.phoneNumber}
            labelClassName="text-[16px] text-[#4a4a4a]"
            className="mt-2 text-[16px] placeholder:text-[16px]"
          />
        </div>
        <hr className="mx-auto my-6 max-w-[34.25rem] border border-[#eee]" />
        <div className="mx-auto flex max-w-[34.25rem] flex-col">
          <label
            htmlFor="content"
            className="ml-2 text-left text-[16px] font-semibold leading-[1.4] text-[#95699f]"
          >
            Content
          </label>
          <textarea
            name="content"
            value={contactUsForm.content}
            onChange={handleInputChange}
            placeholder="Enter your inquiry content. (ex. product name, etc.)"
            className="mt-3 box-border h-[14rem] w-full rounded-lg border border-[#ddd] p-3 placeholder:text-[14px] placeholder:text-[#bbb] focus:outline-none"
          />
          {errors.content && (
            <p className="ml-2 mt-1 text-left text-xs text-red-500">
              {errors.content}
            </p>
          )}
        </div>
        <div className="mx-auto my-5 max-w-[34.25rem] text-left">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="termsOfServiceAgree"
              checked={contactUsForm.termsOfServiceAgree}
              onChange={handleInputChange}
              className="mr-2 inline-block h-5 w-5 cursor-pointer rounded border border-[#bbb] bg-transparent accent-[#8F689A]"
            />
            <Button
              type="button"
              variant="ghost"
              onClick={() => setIsTermsModalOpen(true)}
              className="h-auto p-0 text-[16px] font-medium text-[#666]"
            >
              Agree to the terms of service
            </Button>
          </label>
          {errors.termsOfServiceAgree && (
            <p className="ml-2 mt-1 text-xs text-red-500">
              {errors.termsOfServiceAgree}
            </p>
          )}
        </div>
        <Button
          type="submit"
          variant="primary"
          size="lg"
          className="mt-10 w-full max-w-[34.25rem]"
        >
          POST
        </Button>
      </form>
      <TermsOfServiceModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
      />
    </section>
  );
};

export default ContactUs;
